import { render, staticRenderFns } from "./summy.vue?vue&type=template&id=f9f190f2&scoped=true"
import script from "./summy.vue?vue&type=script&lang=js"
export * from "./summy.vue?vue&type=script&lang=js"
import style0 from "./summy.vue?vue&type=style&index=0&id=f9f190f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0a317e13ddfbb0b64829e4e877bda568/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f190f2",
  null
  
)

export default component.exports